import React from 'react';
import {Link as InertiaLink, router} from '@inertiajs/react';
import PropTypes from 'prop-types';

function Link(props) {
	const filteredProps = Object.keys(props)
		.filter(name => !Link.propTypes.hasOwnProperty(name))
		.reduce((obj, key) => {
			obj[key] = props[key];
			return obj;
		}, {});

	function isCurrentPage(href) {
		const url = new URL(href, window.location.origin);
		const current = window.location;

		return url.origin + url.pathname + url.search === current.origin + current.pathname + current.search;
	}

	const hrefIsCurrentPage = isCurrentPage(props.href ?? '');

	function onFocus(e) {
		if(!hrefIsCurrentPage && (props.prefetchOnFocus ?? true))
			router.prefetch(props.href, {method: 'get'}, {cacheFor: '30s'});

		if(props.onFocus)
			props.onFocus(e);
	}

	return (
		<InertiaLink {...filteredProps}
					 prefetch={!hrefIsCurrentPage && (props.prefetchOnHover ?? true)}
					 onFocus={onFocus}>
			{props.children}
		</InertiaLink>
	);
}

Link.propTypes = {
	prefetchOnHover: PropTypes.bool,
	prefetchOnFocus: PropTypes.bool,
	onFocus: PropTypes.func,
};

export default Link;
